import { useQuery } from 'react-query';
import useIntl from '../../../../hooks/useIntl';
import CountryService from '../../../../services/countryService';
import messages from '../../messages';

export type UseAllCountriesReturn = {
  countries: Array<{ value: ?string, text: string }>,
  isLoading: boolean,
};

export default function useAllCountries(): UseAllCountriesReturn {
  const intl = useIntl();
  const queryKey = 'countries';
  const countryService = new CountryService();

  const { data, isLoading } = useQuery(
    queryKey,
    () => {
      return countryService.getAll();
    },
    { initialData: [], refetchOnWindowFocus: false },
  );

  const dataToReturn = !isLoading
    ? [
        // Add a default empty option
        { value: null, text: intl.formatMessage(messages.selectCountry) },
        ...data.map((country) => ({
          value: country.id,
          text: country.name,
        })),
      ]
    : null;

  return {
    countries: dataToReturn,
    isLoading,
  };
}
